/**
 * @generated SignedSource<<03267b3e6a537d3d03f8a79f45ef5516>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type CalendarSource = "google" | "internal" | "office365";
export type ConferenceCallProvider = "HANGOUTS_MEET" | "MS_TEAMS" | "SKYPE_FOR_BUSINESS" | "UNKNOWN" | "WEBEX" | "ZOOM";
export type EventColor = "CALENDAR" | "GREEN" | "GREY" | "PEACH" | "PROVIDER" | "PURPLE" | "RED" | "ROYAL" | "YELLOW";
export type EventType = "OCCURRENCE" | "RECURRING" | "SINGLE";
export type ResponseStatusChoices = "accepted" | "declined" | "needsAction" | "none" | "notResponded" | "organizer" | "tentative" | "tentativelyAccepted";
export type StatusChoices = "busy" | "cancelled" | "confirmed" | "free" | "needsAction" | "oof" | "tentative" | "unknown" | "workingElsewhere";
export type WillBeRecordedType = "NO" | "RESTRICTED" | "UNKNOWN" | "YES";
export type CalendarPageQuery$variables = {
  end?: string | null;
  start?: string | null;
};
export type CalendarPageQuery$data = {
  readonly viewer: {
    readonly events: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly attendeePersonCount: number;
          readonly calendar: {
            readonly id: string;
            readonly source: CalendarSource;
          };
          readonly calendarColor: string | null;
          readonly conferenceCalls: ReadonlyArray<{
            readonly provider: ConferenceCallProvider;
            readonly url: string;
          }>;
          readonly end: string | null;
          readonly fellowColor: EventColor;
          readonly guid: string;
          readonly hasMeetingRecording: boolean;
          readonly hasNoteContent: boolean;
          readonly hasUnreadNoteContent: boolean;
          readonly id: string;
          readonly isAllDay: boolean;
          readonly isHidden: boolean | null;
          readonly isOrganizer: boolean | null;
          readonly providerEventColor: string | null;
          readonly start: string | null;
          readonly status: StatusChoices;
          readonly timeBlockType: string | null;
          readonly title: string;
          readonly type: EventType;
          readonly userResponseStatus: ResponseStatusChoices | null;
          readonly willBeRecorded: WillBeRecordedType;
        };
      } | null>;
    };
  };
};
export type CalendarPageQuery = {
  response: CalendarPageQuery$data;
  variables: CalendarPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "end"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "start"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": "events",
  "args": [
    {
      "kind": "Variable",
      "name": "end",
      "variableName": "end"
    },
    {
      "kind": "Variable",
      "name": "start",
      "variableName": "start"
    }
  ],
  "concreteType": "EventConnection",
  "kind": "LinkedField",
  "name": "eventsByUserEventFilters",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EventEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Event",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "guid",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "start",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "end",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isAllDay",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isOrganizer",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "userResponseStatus",
              "storageKey": null
            },
            {
              "alias": "providerEventColor",
              "args": null,
              "kind": "ScalarField",
              "name": "color",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "calendarColor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "fellowColor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isHidden",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "type",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ConferenceCall",
              "kind": "LinkedField",
              "name": "conferenceCalls",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "provider",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "url",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Calendar",
              "kind": "LinkedField",
              "name": "calendar",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "source",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNoteContent",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasUnreadNoteContent",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "attendeePersonCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "timeBlockType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasMeetingRecording",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "willBeRecorded",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CalendarPageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CalendarPageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "92daafb4546533bda08cf75344feda11",
    "id": null,
    "metadata": {},
    "name": "CalendarPageQuery",
    "operationKind": "query",
    "text": "query CalendarPageQuery(\n  $end: DateTime\n  $start: DateTime\n) {\n  viewer {\n    events: eventsByUserEventFilters(start: $start, end: $end) {\n      edges {\n        node {\n          id\n          guid\n          start\n          end\n          title\n          isAllDay\n          isOrganizer\n          status\n          userResponseStatus\n          providerEventColor: color\n          calendarColor\n          fellowColor\n          isHidden\n          type\n          conferenceCalls {\n            provider\n            url\n          }\n          calendar {\n            id\n            source\n          }\n          hasNoteContent\n          hasUnreadNoteContent\n          attendeePersonCount\n          timeBlockType\n          hasMeetingRecording\n          willBeRecorded\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "d8c4ca4575f14cab2687fcb8f97d8a96";

export default node;
